/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Seefaqs1Inputs */

const en_help_seefaqs1 = /** @type {(inputs: Help_Seefaqs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See FAQs`)
};

/**
* | output |
* | --- |
* | "See FAQs" |
*
* @param {Help_Seefaqs1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const help_seefaqs1 = /** @type {((inputs?: Help_Seefaqs1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Seefaqs1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_seefaqs1(inputs)
});
export { help_seefaqs1 as "help_seeFaqs" }